module.exports = __webpack_public_path__ + "static/media/check-uncheck-asistance.9278bedb.jpg";